import type { AssetsListTableRowActionsProps } from "./assets-list-table-row-actions.type";

import ListTableRowActions from "@/modules/list-table-row-actions";

import AssetsListTableRowActions from "./assets-list-table-row-actions.component";

const AssetsListTableRowActionsWrapper = (
  props: AssetsListTableRowActionsProps
) => {
  return (
    <ListTableRowActions modelKey="asset" modelId={props.asset.id}>
      <AssetsListTableRowActions {...props} />
    </ListTableRowActions>
  );
};

export default AssetsListTableRowActionsWrapper;
